module.exports = __webpack_public_path__ + "static/media/QualtricsXM_Step2_Image5.07cbd8ab.webp";